import { render, staticRenderFns } from "./WheelPrize.vue?vue&type=template&id=2bc58e13&scoped=true"
import script from "./WheelPrize.vue?vue&type=script&lang=js"
export * from "./WheelPrize.vue?vue&type=script&lang=js"
import style0 from "./WheelPrize.vue?vue&type=style&index=0&id=2bc58e13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc58e13",
  null
  
)

export default component.exports